export interface Environment {
  production: boolean;
  generales: {
    rootUseCaseId : number;
    ico: string;
    inactivityToleration: number;
    activityTolerationTime: number,
  }
  apiUrl: string;
  keyCrypt: string;
  urlBaseBackEnd: string;
  login: string;
  azure: {
    clientId: string;
    authority: string;
    redirectUri: string;
    clientSecret: string;
    tenantId: string;
    postLogoutRedirectUri: string;
  };
  userImageToken: string;
}

export const environment: Environment = {
  production: false,
  generales: {
    rootUseCaseId : 585, // Id de caso uso default que se relacióna con los caso de uso base en TU_CASUSO_FLUEXTEN
    ico: "assets/images/uqroo/sigedo.ico",
    //constantes para el aviso del tiempo de sesión
    inactivityToleration: 5000,
    activityTolerationTime: 10000,
  },

  azure: {
    clientId: 'TU_ID_DE_CLIENTE',
    authority: 'https://login.microsoftonline.com/TENANT_ID',
    redirectUri: 'http://localhost:4200',
    clientSecret: 'TU_CLIENT_SECRET',
    tenantId: 'TU_TENANT_ID',
    postLogoutRedirectUri: ' http://localhost:4200/login',
  },

  apiUrl: 'https://set2.uqroo.mx',
  keyCrypt: 'SIGEDO-2024-K3Y&',
 //urlBaseBackEnd: 'http://localhost:8081/api/v1',
  urlBaseBackEnd: 'https://set-back.uqroo.mx/api/v1',
  login: 's',
  userImageToken: 'TOKEN_IMAGEN_USUARIO_API.',

  //ok
};

export enum Modules {
  AUTH = 'auth',
  LOGIN = 'authenticate',
  USERS = 'users',
  DOCS = 'document',
  FILE = 'fileManager',
  INFO = 'info',
  AUTOCONFIG = 'auto-config',
  GENERATOR = 'generator',
  GENERATORMODULE = 'frame/modulos',
  GENERATORREADER = 'generator-reader',
  NAMEAPI = 'api',
  APPLICATIONS = 'applications',
  USER = 'user',
  CONSTANCIAS = 'constancias',
  O365 = 'o365',
}

export const URLs = {
  minio: `${environment.urlBaseBackEnd}/minio-files`,
  autoConfigController: `${environment.urlBaseBackEnd}/${Modules.AUTOCONFIG}/generales`,
  auth: `${environment.urlBaseBackEnd}/${Modules.AUTH}`,
  authInfo: `${environment.urlBaseBackEnd}/${Modules.AUTH}/info`,
  loginMicrisoft: `${environment.urlBaseBackEnd}/${Modules.O365}`,
  info: `${environment.urlBaseBackEnd}/${Modules.INFO}`,
  login: `${environment.urlBaseBackEnd}/${Modules.AUTH}/${Modules.LOGIN}`,
  refreshToken: `${environment.urlBaseBackEnd}/${Modules.AUTH}/refresh-token`,
  document: `${environment.urlBaseBackEnd}/${Modules.DOCS}`,
  file: `${environment.urlBaseBackEnd}/${Modules.NAMEAPI}/${Modules.FILE}`,
  generator: `${environment.urlBaseBackEnd}/${Modules.GENERATOR}`,
  generatorReader: `${environment.urlBaseBackEnd}/${Modules.GENERATORREADER}`,
  ngenerator: `${environment.urlBaseBackEnd}/${Modules.GENERATOR}`,
  generatorModule: `${environment.urlBaseBackEnd}/${Modules.GENERATORMODULE}`,
  frameConfig: `${environment.urlBaseBackEnd}/frame/config`,
  applications: `${environment.urlBaseBackEnd}/${Modules.APPLICATIONS}`,
  menu: `${environment.urlBaseBackEnd}/${Modules.USER}/menu`,
  useCases: `${environment.urlBaseBackEnd}/${Modules.USER}/usecases`,
  allUseCases: `${environment.urlBaseBackEnd}/${Modules.USER}/usecases/all`,
  systemUseCases: `${environment.urlBaseBackEnd}/${Modules.USER}/system`,
  useCasesByParent: `${environment.urlBaseBackEnd}/${Modules.USER}/useCasesByParent`,
  homepageAccess: `${environment.urlBaseBackEnd}/generator/InicioAccesos`, //URL para los accesos de la página de inicio
  casofluex: `${environment.urlBaseBackEnd}/fluex`,
  rolUseCase: `${environment.urlBaseBackEnd}/rolcase`,
  spdb: `${environment.urlBaseBackEnd}/spdb`,
  dashboardGenerator: `${environment.urlBaseBackEnd}/dashboardGenerator`,
  inputsTypes: `${environment.urlBaseBackEnd}/input-types`,
  inputsProperties: `${environment.urlBaseBackEnd}/input-types/properties`,
  displayModes: `${environment.urlBaseBackEnd}/input-types/display-modes`,
  reportes: `${environment.urlBaseBackEnd}/reportes`,
  respDivAlumnos: `${environment.urlBaseBackEnd}/respdiv/alumnos`,
  adAlumnos: `${environment.urlBaseBackEnd}/ad/alumnos`,
  adTutores: `${environment.urlBaseBackEnd}/ad/tutores`,
  adTutorados: `${environment.urlBaseBackEnd}/ad/tutorados`,
  adRecomendaciones: `${environment.urlBaseBackEnd}/ad/recomendaciones`,
  adAccionTutorial: `${environment.urlBaseBackEnd}/ad/accion-tutorial`,
  adClasificacion: `${environment.urlBaseBackEnd}/ad/clasificacion`,
  adAreasApoyo: `${environment.urlBaseBackEnd}/ad/areas-apoyo`,
  adCausas: `${environment.urlBaseBackEnd}/ad/causas`,
  adUsuariosRoles: `${environment.urlBaseBackEnd}/ad/usuarios-roles`,
  adFirmantes: `${environment.urlBaseBackEnd}/ad/firmantes`,
  adPlantillaConstancia: `${environment.urlBaseBackEnd}/ad/plantilla-constancia`,
  respDivTutores: `${environment.urlBaseBackEnd}/respdiv/tutores`,
  respDivEmpleados: `${environment.urlBaseBackEnd}/respdiv/empleados`,
  respDivUnidades: `${environment.urlBaseBackEnd}/respdiv/unidades`,
  respDivDivisiones: `${environment.urlBaseBackEnd}/respdiv/divisiones`,
  respDivTutorados: `${environment.urlBaseBackEnd}/respdiv/tutorados`,
  tutorTutorados: `${environment.urlBaseBackEnd}/tutor/tutorados`,
  alumnoMiTutor: `${environment.urlBaseBackEnd}/alumno/mi-tutor`,
  alumnoMiCardex: `${environment.urlBaseBackEnd}/alumno/mi-cardex`,
  alumnoMiSimulador: `${environment.urlBaseBackEnd}/alumno/mi-simulador`,
  alumnoMiPerfil: `${environment.urlBaseBackEnd}/alumno/mi-perfil`,
  alumnoMisSesiones: `${environment.urlBaseBackEnd}/alumno/mis-sesiones`,
  alumnoMisRecomendaciones: `${environment.urlBaseBackEnd}/alumno/mis-recomendaciones`,
  tutorEstatus: `${environment.urlBaseBackEnd}/tutor/estatus`,
  tutorRecomendaciones: `${environment.urlBaseBackEnd}/tutor/recomendaciones`,
  tutorAccionTutorial: `${environment.urlBaseBackEnd}/tutor/accion-tutorial`,
  aaCanalizaciones: `${environment.urlBaseBackEnd}/aa/canalizaciones`,
  aaUsuarios: `${environment.urlBaseBackEnd}/aa/usuarios`,
  constanciaVerificar: `${environment.urlBaseBackEnd}/${Modules.CONSTANCIAS}/verificar`,
};
